import RecordSearch from "../components/generated-records/RecordSearch";

const RecordSearchPage = () => {
  return (
    <>
      <RecordSearch />
    </>
  );
};

export default RecordSearchPage;
